import React from "react";

const ZOHO_URL = "https://analytics.zoho.in/open-view/475603000000596174/8949915b4cdec120b79c2722be6ffbf05c54a9f429ea6e1df012138575869c88";

function PurchaseDashboard() {
  return (
    <div className="space-y-4" data-testid="purchase-dashboard">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Purchase Dashboard</h1>
        <p className="text-slate-500 mt-1">Analytics & insights for procurement activities</p>
      </div>
      <div className="w-full rounded-xl overflow-hidden border border-slate-200 bg-white" style={{ height: "calc(100vh - 160px)" }}>
        <iframe
          src={ZOHO_URL}
          title="Purchase Analytics Dashboard"
          className="w-full h-full border-0"
          allow="fullscreen"
          data-testid="purchase-dashboard-iframe"
        />
      </div>
    </div>
  );
}

export default PurchaseDashboard;
